import { default as H1Page } from './H1Page';
import { default as H2Page } from './H2Page';

const EXPORT = { H1Page, H2Page };

export default EXPORT;
